import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight } from 'lodash';

import Banner from '../../components/banner';
import { getPostCover } from '../../services/get-post-cover';
import { fetchLastFeaturedPost } from '../../actions/fetch-last-featured-post';
import withTranslate from '../../hoc/with-translate';
import { getIsAppLoaded } from '../../selectors/is-app-loaded-selectors';
import { getLastFeaturedPost, getLastFeaturedPostCategory } from '../../selectors/last-featured-post-selectors';
import styles from './featured-post-banner.scss';

class FeaturedPostBanner extends React.Component {
  componentDidMount() {
    const { isAppLoaded, fetchLastFeaturedPost } = this.props;
    if (isAppLoaded) {
      fetchLastFeaturedPost();
    }
  }

  render() {
    const { lastFeaturedPost, lastFeaturedPostCategory, t } = this.props;
    if (!lastFeaturedPost) {
      return null;
    }
    const category = lastFeaturedPostCategory && lastFeaturedPostCategory.label;
    const link = { to: `/${lastFeaturedPost.slug}`, text: t('banner.read-more-label') };
    const { shouldRender, imageMetadata } = getPostCover(lastFeaturedPost);
    const image = shouldRender ? imageMetadata : null;
    return (
      <div className={styles.spacer}>
        <Banner title={lastFeaturedPost.title} category={category} link={link} image={image} />
      </div>
    );
  }
}

FeaturedPostBanner.propTypes = {
  lastFeaturedPost: PropTypes.object,
  lastFeaturedPostCategory: PropTypes.object,
  fetchLastFeaturedPost: PropTypes.func.isRequired,
  isAppLoaded: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  lastFeaturedPost: getLastFeaturedPost(state),
  lastFeaturedPostCategory: getLastFeaturedPostCategory(state),
  isAppLoaded: getIsAppLoaded(state),
});

export default flowRight(
  connect(
    mapStateToProps,
    { fetchLastFeaturedPost },
  ),
  withTranslate,
)(FeaturedPostBanner);
